module.exports = __webpack_public_path__ + "static/media/visited_countries.17c336a7.png";